import { render, staticRenderFns } from "./PhotoBook.vue?vue&type=template&id=d2fa623c"
import script from "./PhotoBook.vue?vue&type=script&lang=js"
export * from "./PhotoBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports